import { render } from "./CardRoleList.vue?vue&type=template&id=a931524a"
import script from "./CardRoleList.vue?vue&type=script&lang=js"
export * from "./CardRoleList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__